import api from "../../../../lib/api";
import { IActivityCreate, IActivityListSearch, IEditActivityPayload } from "../../../../types/sales/activityInterface";
import { EditMyActivityByIdPayload, MyActivityListSearch } from "../../../../types/sales/myActivityInterface";

export const createActivityApi = async (data: IActivityCreate) => {
  return await api.post(`/sales/activity`, data);
};

export const getActivityListApi = async (data: IActivityListSearch) => {
  return await api.get(`/sales/activity/${data?.page}/${data?.pageLimit}?type=${data?.type}&search=${data?.search??""}&team=${data?.team ?? 0}`)
}

export const getActivityDataByIdApi = async (id: number) => {
  return await api.get(`/sales/activity/${id}`)
}

export const editActivityDataByIdApi = async (payload: IEditActivityPayload) => {
  return await api.put(`/activity/${payload.id}`, payload.data);
};

export const getMyActivityListApi = async (payload: MyActivityListSearch) => {
  return await api.get(`/sales/my-activity/${payload.page}/${payload.pageLimit}`, {
    params: {
      search: payload?.search ?? "",
      from_date: payload.fromDate,
      to_date: payload.toDate,
      customer_id: payload?.customerId ?? 0,
      lead_id: payload?.leadId ?? 0,
    }
  });
};

export const getMyActivityDataByIdApi = async (id: string) => {
  return await api.get(`/sales/activity/${id}`)
}

export const editMyActivityDataByIdApi = async (payload: EditMyActivityByIdPayload) => {
  return await api.put(`/sales/activity/${payload.id}`, payload.data);
};